/**
 * @fileoverview POST handler for the "/engagement/canvas/items_blocking_steps_or_variations_deletion" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasItemsBlockingStepsOrVariationsDeletionCacheKeys } from "./constants";
import type { PostCanvasItemsBlockingDeletionProps, CanvasItemsBlockingDeletionResult } from "./types";

export const postEngagementCanvasItemsBlockingStepsOrVariationsDeletion = reactQueryMutationAdapter(
  engagementCanvasItemsBlockingStepsOrVariationsDeletionCacheKeys,
  ({
    stepIds,
    variationIds,
    controlVariationIds,
    workflowId,
  }: PostCanvasItemsBlockingDeletionProps): Promise<CanvasItemsBlockingDeletionResult> => {
    // manipulate props here as needed payload

    const body = {
      workflow_step_ids: stepIds,
      variation_ids: variationIds,
      control_variation_ids: controlVariationIds,
      workflow_id: workflowId,
    };
    return fetch("/engagement/canvas/items_blocking_steps_or_variations_deletion", "POST", body, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
